<template>
  <div class="component-sale-chart-home">
    <div class="row align-items-center mb-5">
      <div class="col-lg-4">
        <form-group
          v-if="isProductSelect && !isPaymentTypeSelect"
          v-model="filters.product_id"
          id="product-select"
          placeholder="Selecione o produto"
          select
          slim
          :options="[
            { id: 'all', name: 'Todos os produtos' },
            ...products.map(({ id, name }) => ({ id, name }))
          ]"
        />
      </div>
      <div class="col-lg-5"></div>
      <div class="col-lg-3 mb-3 mb-lg-0">
        <div class="d-flex justify-content-end">
          <period-select
            slim
            id="period-select"
            v-model="filters.period"
            placeholder="Período"
          />
        </div>
      </div>
    </div>
    <div class="chart-card">
      <div v-if="externalLoading" class="text-center pt-9">
        <b-spinner variant="primary" />
      </div>
      <line-chart v-else :data="revenuesByDay" />
    </div>
  </div>
</template>

<script>
import LineChart from "@/components/reports/baseChart/Line.js";
import ChartsMixin from "@/mixins/charts.js";

export default {
  mixins: [ChartsMixin],
  components: {
    LineChart
  },
  props: {
    externalLoading: {
      type: Boolean,
      default: false
    },
    chartColor: {
      type: String,
      default: "#9155EC"
    },
    isPaymentTypeSelect: {
      type: Boolean,
      default: false
    },
    isProductSelect: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      loading: false,
      test: "",
      filters: {
        product_id: "all",
        period: []
      }
    };
  },
  mounted() {
    this.gradientColor = this.chartColor;
    this.$store.dispatch("product/get", { limit: 1000 }).then();
  },
  watch: {
    chartColor(val) {
      this.gradientColor = val; //mixin variable
    },
    externalLoading(val) {
      this.loading = val;
    },
    "filters.product_id"(product_id) {
      this.$emit("change-product", product_id);
    },
    "filters.period"(val) {
      if (val && val.length === 2) {
        this.$emit("change-dates", val);
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.component-sale-chart-home {
  .chart-card {
    min-height: 270px;
    width: 100%;
    flex-grow: 1;

    ::v-deep canvas {
      max-height: 230px;
    }
  }
}
</style>
